export default IconRecordMailOff => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-record-mail-off" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M7 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
  <path d="M18.569 14.557a3 3 0 1 0 -4.113 -4.149" />
  <path d="M7 15h8" />
  <path d="M3 3l18 18" />
</svg>`;